import { useState, useEffect, useRef } from "react";
import React from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Form,
  Input
} from "reactstrap";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { taskmanageService } from "../../services/taskmanageService.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import "assets/css/themecustom-style.css";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import swal from "sweetalert";
import { useParams } from "react-router-dom";

const SubClientSOP = () => {
  const params = useParams();
  const user_info = JSON.parse(localStorage.getItem("user-info"));
  const [clientsearch, setclientsearch] = useState("");
  const [formdetails, setformdetails] = useState({});
  const [formdetailsLen, setformdetailsLength] = useState(0);
  const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
  const [state, setState] = useState({});
  const [formData, setFormData] = useState([]);
  const [disablestate, setdisablestate] = useState(false);

  useEffect(() => {
    get_unique_companieslist();
    if (params.client_id && params.client_id !== "undefined") {
      setclientsearch(params.client_id);
      generateForm(params.client_id);
      getclientstatus();
    }
  }, []);

  const get_unique_companieslist = () => {
    clientmanageService.getuniqueclient().then((response) => {
      setUniqueCompaniesData(response.data);
    });
  };

  const getclientstatus = () => {
    taskmanageService.getclienttransitionstatus().then((res) => {
      if (res.status === 200) {
        // do something with status if needed
      }
    });
  };

  const generateForm = (client_id) => {
    clientmanageService.generateSOPForm(client_id, 5).then((response) => {
      setformdetails(response.data.list);
      setformdetailsLength(Object.entries(response.data.list).length);
      setState(response.data.list);
    });
  };

  const setclient = (e) => {
    setclientsearch(e.value);
    generateForm(e.value);
    getclientstatus();
  };

  // const inputhandler = (e, index, key) => {
  //   let temp_st = { ...state };
  //   let temp_ele = { ...temp_st[key][index] };
  //   temp_ele.remarks = e.target.value;
  //   temp_st[key][index] = temp_ele;
  //   setState(temp_st);
  // };
  const inputhandler = (e, index, key) => {
    const { name, value } = e.target;
    let temp_st = { ...state };
    let temp_ele = { ...temp_st[key][index] };
    temp_ele[name] = value;
    temp_st[key][index] = temp_ele;
    setState(temp_st);
  };

  const inputhandlernew = (e, rowIndex) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newData = [...prevFormData];
      newData[rowIndex] = {
        ...newData[rowIndex],
        [name]: value,
        client_id: clientsearch,
      };
      return newData;
    });
  };

  const handleclick = (id, rowIndex, isNew = false) => {
    swal({
      title: "Are you sure you want to remove?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        if (isNew) {
          // Remove from formData
          setFormData((prev) => {
            const updated = [...prev];
            updated.splice(rowIndex, 1);
            return updated;
          });
  
          // Also update state.formData if it exists
          setState((prevState) => {
            const newState = { ...prevState };
            if (Array.isArray(newState.formData)) {
              newState.formData = [...newState.formData];
              newState.formData.splice(rowIndex, 1);
            }
            return newState;
          });
  
          toast.success("Row removed.");
        } else {
          // For existing data, call backend to delete
          clientmanageService.deleteSOP(id).then((response) => {
            if (response.status === 200) {
              toast.success(response.data.message);
              generateForm(clientsearch); // refresh form
            } else {
              toast.error("Something went wrong!");
            }
          });
        }
      }
    });
  };
  useEffect(() => {
    console.log("Updated formData:", formData);
    console.log("Updated state:", state);
  }, [formData, state]);

  const addsopform = (e) => {
    e.preventDefault();
    setdisablestate(true);
  
    const finalState = { ...state };
    if (formData.length > 0) {
      finalState.formData = formData;
    }
  
    clientmanageService.updateTransitionSOPForm(finalState).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message);
        location.reload();
      }
      setdisablestate(false);
    });
  };
  

  const addNewbox = () => {
    setFormData((prev) => [
      ...prev,
      {
        field_name: "",
        procedures: "",
        remarks: "",
        client_id: clientsearch,
      },
    ]);
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-12">
          <div className="col" style={{ padding: "0%" }}>
            <Card className="shadow">
              {uniquecompanieslist.length > 0 &&
              user_info.role_id !== 13 &&
              (!params.client_id || params.client_id === "undefined") ? (
                <CardHeader className="border-0">
                  <Row className="filter" style={{ padding: "0 1%" }}>
                    <div className="filter" style={{ width: "80%" }}>
                      <div className="col-xl-6 col-md-6 col-xs-12">
                        <h3 className="clientformtag">Client</h3>
                        <Select
                          className="input-group-alternative mb-3"
                          name="user_id"
                          options={uniquecompanieslist}
                          onChange={setclient}
                          isClearable={false}
                        />
                      </div>
                    </div>
                  </Row>
                </CardHeader>
              ) : null}
            </Card>
          </div>
        </Row>

        <Row className="mt-12">
          <Card className="shadow" style={{ width: "100%" }}>
            <Form role="form" id="phase-selection-form" onSubmit={addsopform}>
              <Table className="align-items-center table-flush" responsive>
                <thead>
                  <tr style={{ border: "1px solid #000" }}>
                    <th style={{ border: "1px solid #000" }}>Sr.No.</th>
                    <th style={{ border: "1px solid #000" }}>Particulars</th>
                    <th style={{ border: "1px solid #000" }}>Procedures</th>
                    <th style={{ border: "1px solid #000" }}>Remarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(formdetails).map(([key, value], index) => (
                    <>
                      {value.map((g, i) => (
                        <tr key={i} className="whitespace" style={{ border: "1px solid #000" }}>
                          {i === 0 ? (
                            <>
                              <td style={{ border: "1px solid #000" }}>{index + 1}</td>
                              <td style={{ border: "1px solid #000" }}>{key}</td>
                            </>
                          ) : (
                            <>
                              <td style={{ border: "1px solid #000" }}></td>
                              <td style={{ border: "1px solid #000" }}></td>
                            </>
                          )}
                          <td className="whitespace"  style={{ width: "50%", border: "1px solid #000" }}>
                          <Input
                            bsSize="sm"
                            name="procedures"
                            placeholder="Procedures"
                            type="textarea"
                            value={g.procedures || ""}
                            onChange={(e) => inputhandler(e, i, key)}
                          />
                        </td>
                          <td className="whitespace" style={{ width: "50%", border: "1px solid #000" }}>
                            <Input
                              bsSize="sm"
                              name="remarks"
                              placeholder="Remarks"
                              type="textarea"
                              value={g.remarks || ""}
                              onChange={(e) => inputhandler(e, i, key)}
                            />
                          </td>
                          <td style={{ border: "1px solid #000" }}>
                            <Button
                              className="btn btn-danger"
                              onClick={() => handleclick(g.id, i, false)}
                            >
                              <i className="fa fa-trash"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </>
                  ))}

                  {formData.map((row, key) => (
                    <tr className="whitespace" style={{ border: "1px solid #000" }} key={key}>
                      <td style={{ border: "1px solid #000" }}>{formdetailsLen + key + 1}</td>
                      <td style={{ border: "1px solid #000" }}>
                        <Input
                          bsSize="sm"
                          name="field_name"
                          placeholder="Particular"
                          type="textarea"
                          value={row.field_name}
                          onChange={(e) => inputhandlernew(e, key)}
                        />
                      </td>
                      <td style={{  width: "50%", border: "1px solid #000" }}>
                        <Input
                          bsSize="sm"
                          name="procedures"
                          placeholder="Procedures"
                          type="textarea"
                          value={row.procedures}
                          onChange={(e) => inputhandlernew(e, key)}
                        />
                      </td>
                      <td style={{ width: "50%", border: "1px solid #000" }}>
                        <Input
                          bsSize="sm"
                          name="remarks"
                          placeholder="Remarks"
                          type="textarea"
                          value={row.remarks}
                          onChange={(e) => inputhandlernew(e, key)}
                        />
                      </td>
                      <td style={{ border: "1px solid #000" }}>
                        <Button
                          className="btn btn-danger"
                          onClick={() => handleclick(null, key, true)}
                        >
                          <i className="fa fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Form>

            <br />
            <div className="d-flex">
              <Button
                color="primary"
                className="col-xl-2"
                style={{ flex: "0 0 4.66667%" }}
                type="button"
                onClick={addNewbox}
              >
                Add <i className="fa fa-plus"></i>
              </Button>
              <Button
                color="primary"
                className="col-xl-2"
                style={{ flex: "0 0 4.66667%" }}
                type="submit"
                onClick={addsopform}
                disabled={disablestate}
              >
                {disablestate ? "Sending..." : "Save"}
              </Button>
            </div>
          </Card>
        </Row>
      </Container>
    </>
  );
};

export default SubClientSOP;
